module.exports = __webpack_public_path__ + "static/img/download.dbbe693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/download.png
// module id = 6AFn
// module chunks = 1